import { Icon } from "@intility/bifrost-react";
import type { IconProps } from "@intility/bifrost-react/Icon";
import type { ReactNode } from "react";

// A single labelled read-only field: an icon + label above the value. Laid out
// in a responsive grid so a page's settings read as scannable cells, not a
// stack. Shared by the platform- and client-detail overview summaries.
export function SettingsField({
  icon,
  label,
  children,
}: {
  /** Optional; omit for a label-only field. */
  icon?: IconProps["icon"];
  label: string;
  children: ReactNode;
}) {
  return (
    <div>
      <span
        className="bf-label"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          marginBottom: 6,
        }}
      >
        {icon && <Icon icon={icon} className="bfc-base-2" />}
        {label}
      </span>
      {children}
    </div>
  );
}
